module.exports = __webpack_public_path__ + "static/media/quote-ford-mindset.68337bc5.png";